// extracted by mini-css-extract-plugin
export default {"doodles":"Animation_doodles__xjnzs","animate":"Animation_animate__BCe++"};